import React, { ReactNode } from 'react';
import { SnackbarProvider } from 'notistack';
import { makeStyles } from '@material-ui/core/styles';
import AlertIcon from './svg/AlertIcon';
import SuccessIcon from './svg/SuccessIcon';
import InfoIcon from './svg/InfoIcon';

const useStyles = makeStyles((theme: any) => {
  return {
    success: {
      color: theme.palette.success.main,
      backgroundColor: theme.palette.success.light,
      border: `2px solid ${theme.palette.success['500']}`,
      boxShadow: 'none',
    },
    error: {
      color: theme.palette.error.main,
      backgroundColor: theme.palette.error.light,
      border: `2px solid ${theme.palette.error['500']}`,
      boxShadow: 'none',
    },
    warning: {
      color: theme.palette.warning.main,
      backgroundColor: theme.palette.warning.light,
      border: `2px solid ${theme.palette.warning['500']}`,
      boxShadow: 'none',
    },
    info: {
      color: theme.palette.info.main,
      backgroundColor: theme.palette.info.light,
      border: `2px solid ${theme.palette.info['500']}`,
      boxShadow: 'none',
    },
    snackBarIcon: {
      marginRight: theme.spacing(1),
    },
  };
});

interface Props {
  children: ReactNode;
}

const StyledSnackBarProvider = (props: Props) => {
  const classes = useStyles();

  return (
    <SnackbarProvider
      preventDuplicate
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      classes={{
        variantSuccess: classes.success,
        variantError: classes.error,
        variantWarning: classes.warning,
        variantInfo: classes.info,
      }}
      iconVariant={{
        success: <SuccessIcon className={classes.snackBarIcon} viewBox='0 0 26 26' />,
        error: <AlertIcon className={classes.snackBarIcon} viewBox='0 0 26 26' />,
        warning: <AlertIcon className={classes.snackBarIcon} viewBox='0 0 26 26' />,
        info: <InfoIcon className={classes.snackBarIcon} viewBox='0 0 26 26' />,
      }}
    >
      {props.children}
    </SnackbarProvider>
  );
};

export default StyledSnackBarProvider;
